export const SM_MODAL = 'SM_MODAL';
export const MD_MODAL = 'MD_MODAL';
export const LG_MODAL = 'LG_MODAL';
export const XLG_MODAL = 'XLG_MODAL';
export const SPA_ROOT_ID = 'spa-root';
export const MODAL_WINDOW_CLASSNAME = 'modal-window';
export const MODAL_HEADER_HEIGHT = '60px';
export const MODAL_BODY_MIN_HEIGHT = '216px';
export const MODAL_CLOSE_ICON_ID = 'modal_close_icon';
